import React, { useState, useEffect, useContext, useRef } from 'react'
import { Button } from '@mui/material'
import openSocket from 'socket.io-client'
import './Message.css'
import ActiveSellers from './ActiveSellers'
//import SearchNav from '../../components/molecules/SearchNav'
import ActiveSubjects from './ActiveSubjects'
import Conversations from './Conversations'
//import CommonContext from '../../context/common/commonContext'
//import { apiCall } from '../../common/api'
import Drawer from '@mui/material/Drawer'
import Layout from '@/product/components/templates/Layout'
import MessageContext from '@/product/context/message/messageContext'
import { response } from '@/product/context/common'
import AuthContext from '@/product/context/auth/authContext'
import { LocalLaundryService } from '@mui/icons-material'
import AlertContext from '@/product/context/alert/alertContext'
const Message = () => {
    // let { getLangPhrase, language, phrase, getMsgUnreadCount } = useContext(CommonContext)

    const messageContext = useContext(MessageContext)
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated, loadUser } = authContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const {
        searchactualmessages,
        getAllMessages,
        searchprojectmessages,
        all_messages,
        all_actual_messages,
        all_project_messages,
        deleteMessage,
        searcharchiveMessages,
        saveMessage,
        responseStatus: responseStatusMessage,
        clearResponse,
    } = messageContext
    const [parentMessageData, setParentMessageData] = useState({})
    const [sellerMessages, setSellerMessages] = useState({})
    const [conversations, setConversations] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [showSubjects, setShowSubjects] = useState(false)
    const userRef = useRef(0)
    const [state, setState] = useState({
        left: false,
    })
    const [activeSeller, setActiveSeller] = useState({
        index: '',
        element: '',
    })
    const [activeProject, setActiveProject] = useState({
        index: '',
        element: '',
    })
    const [isArchive, setIsArchive] = useState(false)
    const [selectedSeller, setSelectedSeller] = useState(0)
    const [selectedProject, setSelectedProject] = useState(0)
    const [activeTab, setActiveTab] = useState()
    const [firstTab, setFirstTab] = useState()

    // useEffect(() => {
    //     getLangPhrase(language)
    //     document.title = global.site_title + ' | Messages'
    // }, [language])

    console.log(user, 'useee')

    useEffect(() => {
        loadUser()
    }, [])

    useEffect(() => {
        if (isAuthenticated) {
            setIsLoading(true)
            // setParentMessageData({})
            setTimeout(() => {
                getParentMessageData()
            }, 1000)
        }
    }, [isArchive, isAuthenticated])

    useEffect(() => {
        if (firstTab) {
            setActiveTab(firstTab)
        }
    }, [firstTab])

    const getParentMessageData = () => {
        let parentMessageFromData = {
            archive: isArchive,
        }
        getAllMessages(parentMessageFromData)
    }

    useEffect(() => {
        if (all_messages) {
            console.log('all_messages', all_messages)

            setParentMessageData(all_messages)
            setIsLoading(false)
        }
    }, [all_messages])

    useEffect(() => {
        if (all_project_messages) {
            setSellerMessages(all_project_messages)
        }
    }, [all_project_messages])

    const getProjectMessageData = async (seller_id) => {
        if (seller_id) {
            let getProject = {
                seller_id: seller_id,
                archive: isArchive,
            }
            setSelectedSeller(seller_id)
            searchprojectmessages(getProject)
        }
    }

    const getConverstionData = async (
        seller_id,
        project_id,
        unreadMessageCount
    ) => {
        if (project_id) {
            let getMessage = {
                project_id: project_id,
                seller_id: seller_id ? seller_id : selectedSeller,
                archive: isArchive,
            }

            if (unreadMessageCount != '') {
                getMessage.activemainusertunread = unreadMessageCount
                getMessage.activesellerunread = unreadMessageCount
            }
            setSelectedProject(project_id)
            // setConversations({})
            searchactualmessages(getMessage)
        }
    }

    useEffect(() => {
        if (responseStatusMessage) {
            if (
                responseStatusMessage.status === 'success' &&
                responseStatusMessage.from === 'deleteMessages'
            ) {
                setAlert(
                    'Message Deleted Successfully',
                    responseStatusMessage.status
                )
            } else if (
                responseStatusMessage.status === 'success' &&
                responseStatusMessage.from === 'archive_messages'
            ) {
                setAlert(
                    'Message Status Changed Successfully',
                    responseStatusMessage.status
                )
                // firstTab.click()
            } else if (
                responseStatusMessage.status === 'success' &&
                responseStatusMessage.from === 'saveMessage'
            ) {
                // reset(seller_id, project_id, '')
            }
            clearResponse()
        }
    }, [responseStatusMessage])

    useEffect(() => {
        if (all_actual_messages) {
            setConversations(all_actual_messages)
        }
    }, [all_actual_messages])

    const sellerClickHandler = async (e, index, seller_id) => {
        console.log(seller_id, 'selll')
        e.persist()
        setConversations({})
        setSellerMessages({})
        let result = getProjectMessageData(seller_id)

        if (result) {
            if (activeSeller.element !== undefined) {
                activeSeller.element.classList &&
                    activeSeller.element.classList.remove('active')
            }
            e.currentTarget.classList.add('active')

            setActiveSeller({
                index: index,
                element: e.currentTarget,
            })
        }
        setSelectedProject(0)
        // setConversations({ actualmessages: [] })
    }

    const projectClickHandler = async (
        e,
        index,
        seller_id,
        unreadMessageCount,
        project_id
    ) => {
        e.persist()

        let result = getConverstionData(
            seller_id,
            project_id,
            unreadMessageCount
        )
        if (result) {
            // reset(seller_id, project_id, unreadMessageCount)

            if (activeProject.element !== undefined) {
                activeProject.element.classList &&
                    activeProject.element.classList.remove('active')
            }
            e.currentTarget.classList.add('active')
            setActiveProject({
                index: index,
                element: e.currentTarget,
            })
        }
        userRef.current = project_id
    }

    const handleMessageSubmit = async (values) => {
        let messageFormData = {
            ...values,
            attachinsidename: '',
            attachorginalname: '',
            sellermsgpost: selectedSeller,
            projectmsgpost: selectedProject,
            archive: isArchive ? 1 : 0,
            status: 'open',
            fromadmin: 1,
        }

        console.log('messageFormData', messageFormData)
        saveMessage(messageFormData)
    }

    const handleMessageDelete = async (message_id, seller_id, project_id) => {
        let deleteMessageFormData = {
            id: message_id,
        }
        deleteMessage(deleteMessageFormData)

        // const res = await apiCall('post', '', deleteMessageFormData, '', 'messages/deletemessage')
        // if (res.data.success) {
        //     reset(seller_id, project_id, '')
        // }
    }

    const assignActiveTab = (element) => {
        setFirstTab(element)
    }

    const toggleTab = (e, archiveState) => {
        setConversations({})
        setSellerMessages({})
        setParentMessageData({})
        setIsArchive(archiveState)

        // if (activeTab) {
        //     activeTab.classList.remove('active')
        // }
        // e.currentTarget.classList.add('active')
        // setActiveTab(e.currentTarget)
    }

    const handleActiveTabClick = (e) => {
        toggleTab(e, false)
    }

    const handleArchiveTabClick = (e) => {
        toggleTab(e, true)
    }

    const handleUnarchiveButtonClick = async (seller_id, project_id) => {
        console.log('111')
        let unarchiveFormData = {
            seller_id: seller_id,
            project_id: project_id,
            archive: true,
        }
        searcharchiveMessages(unarchiveFormData)
        handleActiveTabClick()
        // const res = await apiCall('post', '', unarchiveFormData, '', 'messages/archivemessages')
        // if (res.data.success) {
        //     firstTab.click()
        // }
    }

    const handleArchiveButtonClick = async (seller_id, project_id) => {
        let archiveFormData = {
            seller_id,
            project_id: project_id,
        }
        // if (sellerMessages.projectmessages[activeProject.index].from_admin) {
        //     archiveFormData.seller_id =
        //         sellerMessages.projectmessages[activeProject.index].from_id
        // } else {
        //     archiveFormData.seller_id =
        //         sellerMessages.projectmessages[activeProject.index].to_id
        // }
        console.log(sellerMessages, 'messfff')
        console.log(archiveFormData, 'archhh')
        searcharchiveMessages(archiveFormData)
        handleArchiveTabClick()
        // const res = await apiCall('post', '', archiveFormData, '', 'messages/archivemessages')
        // if (res.data.success) {
        //     if (project_id == sellerMessages.projectmessages[activeProject.index].project_id) {
        //         reset(seller_id, project_id, '')
        //     } else {
        //         reset(seller_id, '', '')
        //     }
        // }
    }

    const socketUpdate = (data) => {
        if (user) {
            if (data && user && data.users.includes(user.admin_id)) {
                let seller_id = data.users.filter((e) => e != user.admin_id)[0]
                if (
                    conversations.actualmessages &&
                    conversations.actualmessages.length
                ) {
                    getParentMessageData()
                    getProjectMessageData(seller_id)
                }

                if (data.message.length) {
                    if (
                        userRef.current == data.message[0].project_id ||
                        !userRef.current
                    ) {
                        setSelectedProject(data.message[0].project_id)
                        if (data.type == 'update') {
                            if (
                                conversations.actualmessages &&
                                conversations.actualmessages.length
                            ) {
                                const n = conversations.actualmessages.length
                                conversations.actualmessages[
                                    n - 1
                                ].datearray.push(data.message[0])
                            }
                        } else {
                            getConverstionData(
                                seller_id,
                                data.message[0].project_id,
                                0
                            )
                        }
                    }
                }
            }
        }
    }

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
            transports: ['websocket'],
        })
        socket.on('chatupdate', (data) => {
            data.type = 'update'
            socketUpdate(data)
        })
        socket.on('chatdelete', (data) => {
            data.type = 'delete'
            socketUpdate(data)
        })
        return () => {
            socket.off('chatupdate', (data) => {
                console.log('chatupdateClosed', data)
            })
        }
    }, [user, conversations])

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return
        }

        setState({ ...state, [anchor]: open })
    }

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    {/* <SearchNav handleKeyDown={() => {}} /> */}
                    <div className="messages">
                        <div className="customContainer">
                            <div className="messageTop d-flex justify-content-between align-items-center">
                                <h2>All Messages</h2>
                                <div className="d-flex justify-content-end">
                                    <Button
                                        className={!isArchive ? 'active' : ''}
                                        onClick={handleActiveTabClick}
                                        ref={(element) =>
                                            assignActiveTab(element)
                                        }
                                    >
                                        {`Active(${
                                            parentMessageData.activemsgcount
                                                ? parentMessageData.activemsgcount
                                                : 0
                                        })`}
                                    </Button>
                                    <Button
                                        className={isArchive ? 'active' : ''}
                                        onClick={handleArchiveTabClick}
                                    >
                                        {`Archive(${
                                            parentMessageData.archivemsgcount
                                                ? parentMessageData.archivemsgcount
                                                : 0
                                        })`}{' '}
                                    </Button>
                                </div>
                            </div>
                            <div className="messageCnt">
                                {isArchive ? (
                                    parentMessageData.archivemsgcount > 0 ? (
                                        <>
                                            <div className="messageHead d-flex justify-content-between align-items-center flex-wrap">
                                                <Button
                                                    className="toggleSellers"
                                                    onClick={toggleDrawer(
                                                        'left',
                                                        true
                                                    )}
                                                >
                                                    <span className="material-icons">
                                                        people
                                                    </span>{' '}
                                                    Show Users
                                                </Button>
                                                <h4>Users</h4>
                                                <h5>
                                                    {'Conversations' + ' - '}

                                                    <span>
                                                        {sellerMessages.projectmessages &&
                                                        activeProject.index !==
                                                            ''
                                                            ? sellerMessages
                                                                  .projectmessages[
                                                                  activeProject
                                                                      .index
                                                              ]?.title
                                                            : ''}
                                                    </span>
                                                </h5>

                                                <h6>
                                                    {sellerMessages.projectmessages &&
                                                    activeProject.index !== ''
                                                        ? sellerMessages
                                                              .projectmessages[
                                                              activeProject
                                                                  .index
                                                          ]?.conversationcount +
                                                          ' ' +
                                                          'Conversations'
                                                        : 'Conversations'}
                                                </h6>
                                            </div>
                                            <div className="messageBody d-flex justify-content-start">
                                                <ActiveSellers
                                                    sellers={
                                                        parentMessageData.messagesforusers
                                                    }
                                                    onClick={sellerClickHandler}
                                                    isArchive={isArchive}
                                                />
                                                <ActiveSubjects
                                                    sellerMessages={
                                                        sellerMessages
                                                    }
                                                    onClick={
                                                        projectClickHandler
                                                    }
                                                    isArchive={isArchive}
                                                    handleUnarchiveButtonClick={
                                                        handleUnarchiveButtonClick
                                                    }
                                                    handleArchiveButtonClick={
                                                        handleArchiveButtonClick
                                                    }
                                                />
                                                <Conversations
                                                    conversations={
                                                        conversations
                                                    }
                                                    handleMessageSubmit={
                                                        handleMessageSubmit
                                                    }
                                                    handleMessageDelete={
                                                        handleMessageDelete
                                                    }
                                                />
                                            </div>
                                        </>
                                    ) : isLoading ? (
                                        <div className="nomessage">
                                            Loading...
                                        </div>
                                    ) : (
                                        <div className="nomessage">
                                            No New Messages
                                        </div>
                                    )
                                ) : parentMessageData.activemsgcount > 0 ||
                                  true ? (
                                    <>
                                        <div className="messageHead d-flex justify-content-between align-items-center flex-wrap">
                                            <Button
                                                className="toggleSellers"
                                                onClick={toggleDrawer(
                                                    'left',
                                                    true
                                                )}
                                            >
                                                <span className="material-icons">
                                                    people_alt
                                                </span>{' '}
                                                Show Users
                                            </Button>
                                            <h4>Users</h4>
                                            <h5>
                                                {'Conversations' + ' - '}
                                                {console.log(
                                                    'activeProject.index',
                                                    activeProject.index,
                                                    sellerMessages.projectmessages
                                                )}
                                                <span>
                                                    {sellerMessages.projectmessages &&
                                                    sellerMessages
                                                        .projectmessages
                                                        .length &&
                                                    activeProject.index !==
                                                        '' &&
                                                    sellerMessages
                                                        .projectmessages[
                                                        activeProject.index
                                                    ]
                                                        ? sellerMessages
                                                              .projectmessages[
                                                              activeProject
                                                                  .index
                                                          ].title
                                                        : ''}
                                                </span>
                                            </h5>

                                            <h6>
                                                {sellerMessages.projectmessages &&
                                                sellerMessages.projectmessages
                                                    .length &&
                                                activeProject.index !== '' &&
                                                sellerMessages.projectmessages[
                                                    activeProject.index
                                                ]
                                                    ? sellerMessages
                                                          .projectmessages[
                                                          activeProject.index
                                                      ].conversationcount +
                                                      ' ' +
                                                      'Conversations'
                                                    : 'Conversations'}
                                            </h6>
                                        </div>
                                        <div className="messageBody d-flex justify-content-start">
                                            <ActiveSellers
                                                sellers={
                                                    parentMessageData.messagesforusers
                                                }
                                                onClick={sellerClickHandler}
                                                isArchive={isArchive}
                                            />
                                            <ActiveSubjects
                                                sellerMessages={sellerMessages}
                                                onClick={projectClickHandler}
                                                isArchive={isArchive}
                                                handleUnarchiveButtonClick={
                                                    handleUnarchiveButtonClick
                                                }
                                                handleArchiveButtonClick={
                                                    handleArchiveButtonClick
                                                }
                                            />
                                            <Conversations
                                                conversations={conversations}
                                                handleMessageSubmit={
                                                    handleMessageSubmit
                                                }
                                                handleMessageDelete={
                                                    handleMessageDelete
                                                }
                                            />
                                        </div>
                                    </>
                                ) : isLoading ? (
                                    <div className="nomessage">Loading...</div>
                                ) : (
                                    <div className="nomessage">
                                        No New Messages
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <Drawer
                        anchor="left"
                        open={state['left']}
                        className="msgDrawer"
                        onClose={toggleDrawer('left', false)}
                    >
                        <h4 className="msgHead">
                            {showSubjects === true
                                ? 'Active Conversations'
                                : 'Active Sellers'}
                        </h4>
                        {showSubjects === true ? (
                            <span>
                                <Button
                                    className="backSellerBtn"
                                    onClick={() => setShowSubjects(false)}
                                >
                                    <span className="material-icons">
                                        arrow_back
                                    </span>
                                    Back to Users
                                </Button>
                                <ActiveSubjects
                                    sellerMessages={sellerMessages}
                                    onClick={projectClickHandler}
                                    isArchive={isArchive}
                                    handleUnarchiveButtonClick={
                                        handleUnarchiveButtonClick
                                    }
                                    handleArchiveButtonClick={
                                        handleArchiveButtonClick
                                    }
                                />
                            </span>
                        ) : (
                            <span onClick={() => setShowSubjects(true)}>
                                <ActiveSellers
                                    sellers={parentMessageData.messagesforusers}
                                    onClick={sellerClickHandler}
                                    isArchive={isArchive}
                                />
                            </span>
                        )}
                    </Drawer>
                </div>
            </Layout>
        </>
    )
}

export default Message
